import React from "react";
import { NavLink } from "react-router-dom";
import "../styles/services-grid.css";
import { PhosphorIcon } from "./PhosphorIcon";

/**
 * ServicesGrid — homepage "What we do" section (v7 spec).
 * 3x2 grid, flow layout, Phosphor icons at 24px, one CTA per card.
 * No absolute positioning — uses the shared feature-card styling.
 */

const SERVICES = [
  {
    icon: "Database",
    title: "Oracle ERP Implementation",
    body: "Oracle Fusion, EBS, OIC, VBCS and APEX. From discovery through go-live to knowledge transfer.",
    hover: "Procure-to-Pay, Record-to-Report and Order-to-Cash, with conference-room pilots and clean cutover.",
    ctaLabel: "Explore Oracle practice",
    to: "/services/oracle",
  },
  {
    icon: "ListChecks",
    title: "Managed Services & AMC",
    body: "Post go-live support, enhancements and annual maintenance — your systems stay healthy long after launch.",
    hover: "SLA-backed AMS, quarterly update regression, period-close support and a managed pod aligned to your calendar.",
    ctaLabel: "Talk about support",
    to: "/services/oracle",
  },
  {
    icon: "Receipt",
    title: "E-Invoicing Compliance",
    body: "UAE PINT AE, KSA ZATCA, India GST, Malaysia LHDN and EU PEPPOL. ASP-neutral, ERP-native, mandate-aligned.",
    hover: "Built across SAP, Oracle, Dynamics, NetSuite, Odoo, Zoho, Tally and Sage — clearance, reporting and PEPPOL exchange.",
    ctaLabel: "View compliance services",
    to: "/einvoicing-erp-integration",
  },
  {
    icon: "PlugsConnected",
    title: "Middleware Engineering",
    body: "Enterprise middleware — OIC, Dell Boomi, MuleSoft — and custom Python adapters for ERP-to-ASP integration.",
    hover: "When no middleware exists, we deploy lightweight custom Python adapters so any ERP can integrate cleanly.",
    ctaLabel: "Talk to an engineer",
    to: "/einvoicing-erp-integration",
  },
  {
    icon: "Books",
    title: "Zoho & Odoo ERP",
    body: "Zoho and Odoo implementation, customization and Books workflows for growing and mid-market businesses.",
    hover: "Edition selection, migration from Tally/QuickBooks, and GST/ZATCA-aligned invoicing built in.",
    ctaLabel: "View ERP services",
    to: "/services/zoho",
  },
  {
    icon: "UsersThree",
    title: "Global Staffing & Training",
    body: "IT and non-IT hiring — Oracle, SAP, developers, sales, marketing and product — across India, UAE, KSA, US (C2C/W2) and UK.",
    hover: "Contract, contract-to-hire, permanent and RPO, plus role-based training and enablement programmes.",
    ctaLabel: "View staffing models",
    to: "/services/staffing",
  },
];

export default function ServicesGrid() {
  return (
    <section className="why-cloudare">
      <header className="why-cloudare__header">
        <p className="why-cloudare__eyebrow">What we do</p>
        <h2 className="why-cloudare__title">
          Compliance, ERP and middleware — under one roof
        </h2>
        <p className="why-cloudare__lede">
          Cloudare delivers end-to-end Oracle and Zoho implementations with
          global e-invoicing compliance built into the ERP layer, not bolted on
          after.
        </p>
      </header>

      <div className="why-cloudare__grid">
        {SERVICES.map((s) => (
          <article className="wc-card" key={s.title}>
            <div className="wc-card__icon">
              <PhosphorIcon name={s.icon} size={24} />
            </div>
            <h3 className="wc-card__title">{s.title}</h3>
            <p className="wc-card__body">{s.body}</p>
            {s.hover ? <p className="wc-card__hover">{s.hover}</p> : null}
            {s.href ? (
              <a
                className="wc-card__cta"
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
              >
                {s.ctaLabel} <span aria-hidden="true">→</span>
              </a>
            ) : (
              <NavLink className="wc-card__cta" to={s.to}>
                {s.ctaLabel} <span aria-hidden="true">→</span>
              </NavLink>
            )}
          </article>
        ))}
      </div>
    </section>
  );
}
